<template>
  <div class="animated fadeIn">
    <div v-if="iscreate">
      <createaccessrule @created="iscreate = false"></createaccessrule>
    </div>
    <div v-if="isedit">
      <editaccessrule
        @edit="isedit = false"
        :details="subscriptionData"
      ></editaccessrule>
    </div>
    <div>
      <b-modal id="modal-center-1" size="md" centered hide-footer
        ><viewaccessrule
          @view="isview = false"
          :details="subscriptionData"
        ></viewaccessrule
      ></b-modal>
    </div>
    <b-card
      class="card-wrap"
      header="Access Rule"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      v-if="!iscreate && !isedit && !isview"
    >
      <b-row>
        <b-col md="12" v-if="!iscreate && !isedit && !isview">
          <eb-button
            class="btn float-right mr-2"
            classic="mr-1 btn-primary"
            text="Create Access Rule"
            icon="fa fa-plus-circle mr-1"
            iconSide="left"
            @click="iscreate = true"
          ></eb-button>
        </b-col>
      </b-row>
      <div class="mt-2" v-if="!iscreate && !isedit && !isview">
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          :items="accessrulesList"
          thead-class="header"
          class="mt-3 tableRadius"
          :fields="Columns"
          show-empty
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2 butto-circle"
              variant="primary"
              @click="Viewaccessrule(data)"
              v-b-modal.modal-center-1
            >
              <i class="fa fa-eye"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 butto-circle"
              variant="primary"
              @click="Editaccessrule(data)"
            >
              <i class="fas fa-pencil-alt edit"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 butto-circle"
              variant="danger"
              @click="deleteSubscription(data)"
            >
              <i class="fa fa-trash bin"></i>
            </b-button>
          </template>
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
        </b-table>
      </div>
      <div
        style="float: right"
        v-if="!iscreate && !isedit && !isview && accessrulesList.length > 0"
      >
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="accessrulesList.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import Createaccessrule from "@/components/MasterSetup/accessrules/CreateAccessrule";
import Editaccessrule from "@/components/MasterSetup/accessrules/EditAccessrule";
import Viewaccessrule from "@/components/MasterSetup/accessrules/ViewAccessrule";

export default {
  name: "Coupondetails",
  components: {
    ebButton,
    loader,
    Createaccessrule,
    Editaccessrule,
    Viewaccessrule,
  },
  data() {
    return {
      perPage: 30,
      iscreate: false,
      isedit: false,
      isview: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      sortBy: "createdAt",
      sortDesc: true,
      faqModal: false,
      header: "Edit Faq",
      subscriptionData: {},
      Columns: [
        {
          key: "Name",
          sortable: true,
        },
        {
          key: "Keys",
        },
        {
          key: "action",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("accessrule/accessRuleList");
  },
  computed: {
    accessrulesList() {
      let data = this.$store.getters["accessrule/accessRuleList"];
      this.loading = false;
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => {
          return {
            Name: d.name.toUpperCase(),
            Keys: d.keys,
            itemId: d._id,
          };
        });
      }
      return [];
    },
  },
  methods: {
    Editaccessrule(data) {
      this.isedit = true;
      //console.log("dta rules", data);
      this.subscriptionData = {
        name: data.item["Name"],
        keys: data.item["Keys"],
        ruleId: data.item.itemId,
      };
    },
    Viewaccessrule(data) {
      // this.isview = true;
      this.subscriptionData = {
        Name: data.item["Name"],
        Keys: data.item["Keys"],
      };
    },

    // deleteSubscription(couponcode) {
    //   this.$swal({
    //     title: "Delete this coupon?",
    //     text: "Are you sure? You won't be able to revert this!",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     confirmButtonText: "Yes, Delete it!"
    //   }).then(result => {
    //     if (result.value) {
    //       this.$store
    //         .dispatch("coupon/deleteCouponcode", {
    //           promoCode: couponcode.item.CouponCode
    //         })
    //         .then(result => {
    //           this.$toasted.success("coupon Deleted Successfully");
    //           this.$store
    //             .dispatch(
    //               "accessrule/accessRuleList",
    //               this.$store.getters["auth/getUserID"]
    //             )
    //             .catch(error => {
    //               this.$toasted.error(error.message);
    //             });
    //         });
    //     }
    //   });
    //   this.$store.dispatch(
    //     "accessrule/accessRuleList",
    //     this.$store.getters["auth/getUserID"]
    //   );
    // }
  },
  async mounted() {
    await this.$store
      .dispatch(
        "accessrule/accessRuleList",
        this.$store.getters["auth/getUserID"]
      )
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
